import { Component, OnInit } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { tap, map, take } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';
import { RedirectURL } from '../../utils/urlString';

const COUNTDOWN_DURATION_SECONDS = 180; //in seconds

@Component({
	selector: 'app-maintenance',
	template: require('./app-maintenance.component.html'),
	styles: [require('./app-maintenance.component.scss')],
	host: { class: 'flex flex-col flex-1 overflow-hidden' },
})
export class AppMaintenanceComponent implements OnInit {
	countdown$: Observable<number | null> = timer(0, 1000).pipe(
		map(time => COUNTDOWN_DURATION_SECONDS - time),
		take(COUNTDOWN_DURATION_SECONDS + 1),
		tap(count => (count <= 0 ? this.redirectPage() : null))
	);

	constructor(private readonly route: ActivatedRoute, private readonly sanitizer: DomSanitizer) {}

	ngOnInit() {}

	redirectPage() {
		const redirect = this.route.snapshot.queryParamMap.get('redirect');
		const sanitizedRedirect = redirect ? this.sanitizer.sanitize(SecurityContext.URL, redirect) : null;
		const finalRedirect = sanitizedRedirect ? RedirectURL(sanitizedRedirect) : null;
		window.location.replace(finalRedirect || '/');
	}
}
